var $ = require('jquery');
var jQuery=$;
$(document).ready(function(){
    $('.insights-slider').slick({
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3.2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        responsive: [
         {
             breakpoint: 1024,
             settings: {
                 slidesToShow: 2.2,
                 slidesToScroll: 1,
                 arrows: true
             }
         },
           {
               breakpoint: 767,
               settings: {
                   slidesToShow: 1.2,
                   slidesToScroll: 1,
                   arrows: true
               }
           }, 
     ]             
      });
});

$(document).ready(function () {
    $('.moreless-button-insights').click(function () {
          var rxr = $(this).attr('data-less');
          var actval = $(this).attr('data-actual');
          var dataul=$(this).attr('data-ul');
          if (rxr == '- See less') {
              $(this).attr('data-less', '+ See more');
              $('.'+dataul).css("display","block");
              $(this).text(rxr);
          }
          else {
              $(this).attr('data-less', '- See less');
              $('.'+dataul).css("display","none");
              $(this).text(actval);
          }
    
      }); 
   var siteurl=window.location.href;
   var insightsurl="/insights/insights?tag=";
   
    $('.insights-landing-filter input').change(function () {
        var value = $(this).attr("value");
        $("#loadtop").show();
        if (value == 'Investment insights') {
            window.location.href = insightsurl.replace('/insights/insights?tag=', '/insights/') + $(this).attr("data-url");
        }
        else{
        window.location.href = insightsurl + value;
        }
    })
    $('.insights-landing-filter-authors input').change(function () {
        var url = $(this).attr("data-url");
        $("#loadtop").show();
        window.location.href = url;
    })
    $('.insights-landing-filter-inv').click(function () {
        var value = $(this).attr("value");
        $("#loadtop").show();
        window.location.href = insightsurl + value;
    })
    $("#insights-landing-search").keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            $("#loadtop").show();
            var filter = $(this).val();
            window.location.href = insightsurl + filter;
        }
    });
    
});


// insights-filter start

$(document).ready(function () {
    var assetFilter = [];
    var regionFilter = [];
    var pubFilter = [];
    var formatFilter = [];
    var investment_theme = [];
    var investerTypeFilter = [];
    var lighterFilter = [];
    var searchQuery = "";
    var authors = [];
    var isload = true;
    var totalItems = $('.insights-total-count').attr("value");
    var takeItems = $('.insights-take-count').attr("value");
    var skipItems = $('.insights-skip-count').attr("value");
    var basictake = 10;
    var tagName = "";
    if (window.location.href.indexOf('?tag') > -1) {

        tagName = window.location.href.toString().toLowerCase().split('?tag=')[1];
        var encodetext = encodeURIComponent(tagName.replace(/%20/g, " "));
        var decodetext = decodeURIComponent(decodeURIComponent(encodetext));
        tagName=decodetext;
        $(".search-populer-topics li a").each(function (index) {
            var dataurl = $(this).attr("value");
            if (dataurl.toLowerCase() == tagName.toLowerCase().replace("%20", " ")) {
                $(this).addClass('active');
            }
        });
        $("#insights-searchpage-search").val(tagName.replace("%20", " "));
        $(".insights-search-filter input").each(function (index) {
            var dataurl = $(this).attr("value");
            var parent = $(this).attr("data-filter-tab");
            if (dataurl.toLowerCase() == tagName.toLowerCase()) {
                $(this).prop('checked', true);
                var id1 = $(".styled-checkbox.investmentthemelist[value='" + dataurl + "']").parent().parent();
                    if (id1.hasClass('moretext')) {
                        id1.show();
                        $(id1).parent().find('.moreless-button-insights').attr('data-less', '+ See more');
                        $(id1).parent().find('.moreless-button-insights').text('- See less');
                    }
                    var id2 = $(".styled-checkbox.authorlist[value='" + dataurl + "']").parent().parent();
                    if (id2.hasClass('moretext')) {
                        id2.show();
                        $(id2).parent().find('.moreless-button-insights').attr('data-less', '+ See more');
                        $(id2).parent().find('.moreless-button-insights').text('- See less');
                    }
                    
                var filtervalue = $(this).attr("value");
        var filtergroup = $(this).attr("data-filter-tab");
        pushCategory(filtervalue, filtergroup);
                //$(this).prop('disabled', true);
                $('.' + parent+' button').click();
                //$("#headingTwo button").click();
            }
        });
    }
    if (window.location.href.indexOf('?author') > -1) {
        var auth = window.location.href.toString().toLowerCase().split('?author=')[1];
        pushCategory(auth, "Author");
        basictake = 9;

    }
    if (window.location.href.indexOf('asian-expert-series') > -1) {
        $("#insights-searchpage-search").val("asian expert series");
        tagName="asian expert series";
    }
    if (window.location.href.indexOf('webinars') > -1) {
        formatFilter.push("webinars");
    }
    $('.insights-search-filter-inv').click(function () {
        var filtervalue = $(this).attr("value");
        var filtergroup = $(this).attr("data-filter-tab");
        $('.Mfilterclose img').click();
        if ($(this).prop('checked') == true) {
            pushCategory(filtervalue, filtergroup);
        }
        else {
            popCategory(filtervalue, filtergroup);
        }
        GetMoreSearchInsightsFilters(basictake, 0, searchQuery, assetFilter, regionFilter, pubFilter, formatFilter, investerTypeFilter,lighterFilter, authors, tagName);
    });
    $('.insights-search-filter input').change(function () {
        var filtervalue = $(this).attr("value");
        var filtergroup = $(this).attr("data-filter-tab");
        if (filtergroup == "PublicationType") {
            if (window.location.href.indexOf('asian-expert-series') > -1) {
                $("#insights-searchpage-search").val("");
                tagName="";
            }
            if (filtervalue.toLocaleLowerCase() == "investment insights") {
                if ($(this).prop('checked') == true) {
                    tagName = "asian expert series";
                }
                else {
                    tagName = "";
                }
            }
        }
        $('.Mfilterclose img').click();
        
        if ($(this).prop('checked') == true) {
            if ($(this).attr("data-url") == 'investment-insights') {
                $(".investment-insights").each(function (index) {
                    var _val = $(this).attr("value");
                    pushCategory(_val, filtergroup);
                });
            }
            else {
            pushCategory(filtervalue, filtergroup);
        }
        }
        else {
            if ($(this).attr("data-url") == 'investment-insights') {
                $(".investment-insights").each(function (index) {
                    var _val = $(this).attr("value");
                    popCategory(filtervalue, filtergroup);
                    popCategory(_val, filtergroup);
                });
            }
        else {
            popCategory(filtervalue, filtergroup);
        }
        }
        GetMoreSearchInsightsFilters(basictake, 0, searchQuery, assetFilter, regionFilter, pubFilter, formatFilter, investerTypeFilter,lighterFilter, authors, tagName);
    })
    $("#insights-searchpage-search").keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            searchQuery = $(this).val();
            var encodetext = encodeURIComponent(searchQuery.replace(/%20/g, " "));
        var decodetext = decodeURIComponent(decodeURIComponent(encodetext));
        searchQuery=decodetext;
            $("#insights-searchpage-search").val(searchQuery);
            GetMoreSearchInsightsFilters(basictake, 0, searchQuery, assetFilter, regionFilter, pubFilter, formatFilter, investerTypeFilter,lighterFilter, authors, tagName);
        }
    });
    if (window.location.href.indexOf('?tag') == -1) {
    $(".search-populer-topics li a").on("click", function (e) {
        e.preventDefault();
        var hascls=$(this).hasClass('active');
            if (hascls) {
            $(this).removeClass('active');
            tagName="";
        }
        else{
            $(".search-populer-topics li a").removeClass('active');
            $(this).addClass('active');
            tagName = $(this).attr("value");
            var encodetext = encodeURIComponent(tagName.replace(/%20/g, " "));
        var decodetext = decodeURIComponent(decodeURIComponent(encodetext));
        tagName=decodetext;
        }
        $("#insights-searchpage-search").val(tagName);
        GetMoreSearchInsightsFilters(basictake, 0, searchQuery, assetFilter, regionFilter, pubFilter, formatFilter, investerTypeFilter,lighterFilter, authors, tagName);
    })
}

    /*  filter highligting js start*/
    var insightsURL = window.location.href.toLowerCase();
    var category = insightsURL.split('/insights/')[1];
    $(".insights-search-filter-inv").each(function (index) {
        var dataurl = $(this).attr("data-url");
        if (window.location.href.indexOf('?tag') > -1) {
            tagName = "";
        }
        if (dataurl == category) {
            $(this).prop('checked', true);
            //$(this).prop('disabled', true);
            var filtervalue = $(this).attr("value");
            var filtergroup = $(this).attr("data-filter-tab");
            //$('.Mfilterclose img').click();
            if ($(this).prop('checked') == true) {
                pushCategory(filtervalue, filtergroup);
            }
            else {
                popCategory(filtervalue, filtergroup);
            }
        }
    });
    $(".insights-publication-filter input").each(function (index) {
        var dataurl = $(this).attr("data-url");
        if (window.location.href.indexOf('?tag') > -1) {
        tagName="";
    }
        if (dataurl == category) {
            if (category == 'investment-insights') {
                $('.investment-insights').prop('checked', true);
                $(this).prop('checked', true);
            }
            else {
            $(this).prop('checked', true);
            }
            var filtervalue = $(this).attr("value");
        var filtergroup = $(this).attr("data-filter-tab");
        //$('.Mfilterclose img').click();
        if ($(this).prop('checked') == true) {
            pushCategory(filtervalue, filtergroup);
                if (category == 'investment-insights') {
                    
                    $(".investment-insights").each(function (index) {

                        var _val = $(this).attr("value");
                        pushCategory(_val, filtergroup);
                    });
                }
        }
        else {
                if (category == 'investment-insights') {
                    $(".investment-insights").each(function (index) {
                        var _val = $(this).attr("value");
                        popCategory(_val, filtergroup);
                    });
                    //tagName = "";
                }
            popCategory(filtervalue, filtergroup);
        }
        var datafilter = $(this).attr('data-filter-tab');
        $(".accordion-header").each(function (index) {
            if ($(this).hasClass(datafilter)) {
                $('.' + datafilter + ' button').click();
            }
        });
        }
    });
    var footerheight = ($(".footer--wrap").height());
    if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
        footerheight = footerheight / 2;
    }

    /*   filter highligting js end*/
    if (window.location.href.indexOf("/insights/") > -1) {
    window.onscroll = function (ev) {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - footerheight) {
            totalItems = $('.insights-total-count').attr("value");
            takeItems = $('.insights-take-count').attr("value");
            skipItems = $('.insights-skip-count').attr("value");
            if (isload && parseInt(totalItems) > 10) {
                isload = false;
                takeItems = 6;
                if (skipItems == 0) {
                    skipItems = 10;
                }
                if (parseInt(totalItems) > 10) {
                    LoadMoreSearchInsights(takeItems, skipItems, searchQuery, assetFilter, regionFilter, pubFilter, formatFilter, investerTypeFilter,lighterFilter, authors, tagName);
                }

            }

            // you're at the bottom of the page
        }
    };
}
    function pushCategory(filterValue, filterGroup) {
        if (filterGroup == "Assetclass") {
            assetFilter.push(filterValue);
        }
        else if (filterGroup == "PublicationType") {
            pubFilter.push(filterValue);
        }
        else if (filterGroup == "Region") {
            regionFilter.push(filterValue);
        }
        else if (filterGroup == "Investortype") {
            investerTypeFilter.push(filterValue);
        }
        else if (filterGroup == "Lighterreads") {
            lighterFilter.push(filterValue);
        }
        else if (filterGroup == "Author") {
            authors.push(filterValue);
        }
        else if (filterGroup == "Format") {
            formatFilter.push(filterValue);
        }

    }
    function popCategory(filterValue, filterGroup) {
        if (filterGroup == "Assetclass") {
            assetFilter = jQuery.grep(assetFilter, function (value) {
                return value != filterValue;
            });
        }
        else if (filterGroup == "PublicationType") {
            pubFilter = jQuery.grep(pubFilter, function (value) {
                return value != filterValue;
            });
        }
        else if (filterGroup == "Region") {
            regionFilter = jQuery.grep(regionFilter, function (value) {
                return value != filterValue;
            });
        }
        else if (filterGroup == "Investortype") {
            investerTypeFilter = jQuery.grep(investerTypeFilter, function (value) {
                return value != filterValue;
            });
        }
        else if (filterGroup == "Lighterreads") {
            lighterFilter = jQuery.grep(lighterFilter, function (value) {
                return value != filterValue;
            });
        }
        else if (filterGroup == "Author") {
            authors = jQuery.grep(authors, function (value) {
                return value != filterValue;
            });
        }
        else if (filterGroup == "Format") {
            formatFilter = jQuery.grep(formatFilter, function (value) {
                return value != filterValue;
            });
        }

    }
    function LoadMoreSearchInsights(takeCount, skipCount, searchKey, searchAsset, searchRegion, searchPub, searchFormat, investtype,ligherread, authors, tagName) {
        $('#loadtop').show();
        var token = $('input[name="__RequestVerificationToken"]').val();
        var assset = "", region = "", pub = "", format = "", inv_theme = "",light="", author = "";
        if (searchAsset.length > 0) {
            assset = searchAsset;
        }
        if (searchRegion.length > 0) {
            region = searchRegion;
        }
        if (searchPub.length > 0) {
            pub = searchPub;
        }
        if (searchFormat.length > 0) {
            format = searchFormat;
        }
        if (investtype.length > 0) {
            inv_theme = investtype;
        }
        if (authors.length > 0) {
            author = authors;
        }
        if (ligherread.length > 0) {
            light = ligherread;
        }
        var insightsFilterURL = window.location.pathname + "/morePerspectivesFilter";
        if (window.location.href.indexOf('?id') > -1) {
            insightsFilterURL = window.location.href.toString().toLowerCase().split('?id')[0] + "/morePerspectivesFilter" + "?id" + window.location.href.toString().toLowerCase().split('?id')[1];
        }
        //var insightsFilterURL = window.location.pathname + "/morePerspectivesFilter";
        if (window.location.href.indexOf('?tag') > -1) {
            insightsFilterURL = window.location.href.toString().toLowerCase().split('?tag')[0] + "/morePerspectivesFilter" + "?tag" + window.location.href.toString().toLowerCase().split('?tag')[1];
        }
        if (window.location.href.indexOf('?author') > -1) {
            var authorParameter = window.location.href.toString().toLowerCase().split('?author=')[1];
            insightsFilterURL = window.location.pathname + "/morePerspectivesFilter" + '?author=' + authorParameter;
        }
        if ($('#styled-checkbox-12').is(':checked')) {
            tagName = "asian expert series";
        }
        $.ajax({
            type: "POST",
            cache: false,
            dataType: "html",
            url: insightsFilterURL,
            data: { __RequestVerificationToken: token, takeCount: takeCount, skipCount: skipCount, searchKey: searchKey, assetCategory: assset, regionCategory: region, pubCategory: pub, formatCategory: format, investortype: inv_theme, lighterreadsCategory: light, authors: author, tagName: tagName, isloadmore: true },
            success: function (response) {
                skipitems = takeCount;
                if (response.length > 0) {
                    var insightsresult = response;
                    if (insightsresult != null && insightsresult != undefined) {
                        var strtindex = insightsresult.indexOf("<!-- search insights list start -->");
                        var endindex = insightsresult.indexOf("<!-- search insights list end -->");
                        var res = insightsresult.substring(strtindex, endindex);
                        $('.search-insights-list').append(res);
                        $('.insights-take-count').attr("value", takeCount)
                        $('.insights-skip-count').attr("value", parseInt(takeCount) + parseInt(skipCount))
                        if (totalItems > (parseInt(takeCount) + parseInt(skipCount))) {
                            isload = true;
                        }
                        else {
                            isload = false;
                        }
                    }
                    $(".video--play").colorbox({
                        iframe: true,
                        width: '100%',
                        height: '100%',
                        maxWidth: 750,
                        maxHeight: 400
                    });
                    $('#loadtop').hide();

                    return true;
                }
                else {
                    $('#loadtop').hide();

                }

            },
            failure: function (response) {
                $('#loadtop').hide();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                alert(xhr.status);
                alert(thrownError);
                $('#loadtop').hide();
            }
        })
    }
    function GetMoreSearchInsightsFilters(takeCount, skipCount, searchKey, searchAsset, searchRegion, searchPub, searchFormat, investtype,ligherread, authors, tagName) {
        $('#loadtop').show();
        var token = $('input[name="__RequestVerificationToken"]').val();
        var assset = "", region = "", pub = "", format = "", inv_theme = "",light="", author = "";
        if (searchAsset.length > 0) {
            assset = searchAsset;
        }
        if (searchRegion.length > 0) {
            region = searchRegion;
        }
        if (searchPub.length > 0) {
            pub = searchPub;
        }
        if (searchFormat.length > 0) {
            format = searchFormat;
        }
        if (investtype.length > 0) {
            inv_theme = investtype;
        }
        if (authors.length > 0) {
            author = authors;
        }
        if (ligherread.length > 0) {
            light = ligherread;
        }

        var insightsFilterURL = window.location.pathname + "/morePerspectivesFilter";
        if (window.location.href.indexOf('?id') > -1) {
            insightsFilterURL = window.location.href.toString().toLowerCase().split('?id')[0] + "/morePerspectivesFilter" + "?id" + window.location.href.toString().toLowerCase().split('?id')[1];
        }
        if (window.location.href.indexOf('?tag') > -1) {
            insightsFilterURL = window.location.href.toString().toLowerCase().split('?tag')[0] + "/morePerspectivesFilter" + "?tag" + window.location.href.toString().toLowerCase().split('?tag')[1];
        }
        //var insightsFilterURL = window.location.pathname + "/morePerspectivesFilter";
        if (window.location.href.indexOf('?author') > -1) {
            var authorParameter = window.location.href.toString().toLowerCase().split('?author=')[1];
            insightsFilterURL = window.location.pathname + "/morePerspectivesFilter" + '?author=' + authorParameter;
        }
        if ($('#styled-checkbox-12').is(':checked')) {
            tagName = "asian expert series";
        }
        $.ajax({
            type: "POST",
            cache: false,
            //contentType: "application/json; charset=utf-8",
            dataType: "html",
            url: insightsFilterURL,
            //data: "{'takeCount':" + takeCount + ",'skipCount':" + skipCount + ",'searchKey':'" + searchKey + "','assetCategory':'" + assset + "','regionCategory':'" + region + "','publicationCategory':'" + pub + "','formatCategory':'" + format + "','lighterCategory':'" + lighter + "','investorType':'" + investors + "'}",
            data: {
                __RequestVerificationToken: token, takeCount: takeCount, skipCount: skipCount, searchKey: searchKey, assetCategory: assset,
                regionCategory: region, pubCategory: pub, formatCategory: format, investortype: inv_theme,lighterreadsCategory:light, authors: author, tagName: tagName
            },
            success: function (response) {
                skipitems = takeCount;
                $('.search-insights-list').empty();
                //var res = JSON.parse(response);

                $('.noinsights').hide();
                if (response.length > 0) {
                    $('.noPersp').hide();
                    var insightsresult = response;
                    if (insightsresult != null && insightsresult != undefined) {
                        var strtindex = insightsresult.indexOf("<!-- search insights start -->");
                        var endindex = insightsresult.indexOf("<!-- search insights end -->");
                        var res = insightsresult.substring(strtindex, endindex);
                        $('.search-insights-list').html(res);
                        if (res.length < 1) {
                            $('.noinsights').show();
                        }
                    }
                    $(".video--play").colorbox({
                        iframe: true,
                        width: '100%',
                        height: '100%',
                        maxWidth: 750,
                        maxHeight: 400
                    });
                    $('#loadtop').hide();
                    var total=$('.insights-total-count').attr("value");
                    $('.insights-total-count').attr("value", total);
                    $('.insights-take-count').attr("value", takeCount);
                    $('.insights-skip-count').attr("value", parseInt(takeCount) + parseInt(skipCount));
                    if (total > (parseInt(takeCount) + parseInt(skipCount))) {
                        isload = true;
                    }
                    else {
                        isload = false;
                    }
                    return true;
                }
                else {
                    $('.noinsights').show();
                    //$('#noperspective').hide();
                    $('.lightbox_load--more_perspective').hide();
                    $('#loadtop').hide();

                }

            },
            failure: function (response) {
                $('#loadtop').hide();
            },
            error: function (xhr, ajaxOptions, thrownError) {
                alert(xhr.status);
                alert(thrownError);
                $('#loadtop').hide();
            }
        })
    }
    /* filter reset*/
    $("#insights-search-filter-reset").click(function () {
        $(".styled-checkbox:not(:disabled)").prop('checked', false);
        searchQuery = ""; assetFilter = []; regionFilter = []; pubFilter = []; formatFilter = [];
        formatFilter = []; investerTypeFilter = []; lighterFilter=[]; authors = []; tagName = "";
        if (window.location.href.indexOf('?tag') > -1) {
            tagName = window.location.href.toString().toLowerCase().split('?tag=')[1];
            var encodetext = encodeURIComponent(tagName.replace(/%20/g, " "));
            var decodetext = decodeURIComponent(decodeURIComponent(encodetext));
            tagName=decodetext;
            $("#insights-searchpage-search").val(tagName.replace("%20", " "));
        }
        if (window.location.href.indexOf('?author') > -1) {
            var auth = window.location.href.toString().toLowerCase().split('?author=')[1];
            pushCategory(auth, "Author");
        }
        $(".search-populer-topics li a").removeClass('active');
        if (window.location.href.indexOf('asian-expert-series') > -1) {
            $("#insights-searchpage-search").val("");
            tagName="";
        }
        GetMoreSearchInsightsFilters(basictake, 0, searchQuery, assetFilter, regionFilter, pubFilter, formatFilter, investerTypeFilter,lighterFilter, authors, tagName);
    })

});


// insights filter end

